import { Route, Routes } from 'react-router-dom'
import Blog from './Pages/Home/Blog/Blog'
import Booking from './Pages/Home/Booking/Booking'
import Contact from './Pages/Home/Contact/Contact'
import AllDestinations from './Pages/Home/Destination/AllDestinations'
import Destination from './Pages/Home/Destination/Destination'
import Home from './Pages/Home/Home'
import Vehicle from './Pages/Home/Vehicle/Vehicle'
import Login from './Pages/Login/Login/Login'
import RequireAuth from './Pages/Login/RequireAuth/RequireAuth'
import SignUp from './Pages/Login/SignUp/SignUp'

function App() {
    return (
        <div>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route
                    path="/destination"
                    element={
                        <RequireAuth>
                            <AllDestinations/>
                        </RequireAuth>
                    }
                />
                <Route path="/destination/:name" 
                       element={
                        <RequireAuth>
                            <Booking />
                        </RequireAuth>
                    } 
                />
                <Route
                    path="/destination/:name/hotels"
                    element={
                        <RequireAuth>
                            <Destination />
                        </RequireAuth>
                    }
                />
                <Route path="/vehicle" 
                    element={
                        <RequireAuth>
                            <Vehicle/>
                        </RequireAuth>
                    }
                />
                <Route path="/blog" element={<Blog/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
            </Routes>
        </div>
    )
}

export default App
